import { DatahubUtils } from 'src/utils/datahub';
import { SendDataHubProps } from 'src/utils/datahub/types';

const useDispatchDatahubCommunity = () => {
  const platformDetail =
    window.navigator?.userAgentData?.platform || window.navigator?.platform || 'unknown';
  const osVersion = window.navigator?.userAgent || window.navigator?.appVersion || 'unknown';

  const dispatchDatahubCommunity = ({
    entity,
    action,
    event,
    membershipData,
    userData,
    appVersion,
    system
  }: SendDataHubProps) => {
    DatahubUtils.sendEvent(
      {
        entity,
        action,
        event: {
          platformDetail,
          osVersion,
          url: window.location.href,
          appVersion,
          ...event,
          ...membershipData,
          ...userData
        }
      },
      system
    );
  };

  return { dispatchDatahubCommunity };
};

export default useDispatchDatahubCommunity;
